import React, { useReducer } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { media } from "../../styles";
import SizerRatesTabel from "../../components/SizerRates";
import {
  Grid,
  Section,
  Button,
  BreadCrumbBox,
  Modal,
  Loading,
} from "../../core";
import AddSizerQualityRate from "../../components/AddSizerQualityRate";
import { reducer, initialState } from "../../hooks/modalReducer";
import { useParams } from "react-router-dom";
import { useSizerData, parseSizerRates } from "../../hooks/useSizerData";

const btnProps = {
  bg: "#FF5687",
  width: "155px",
  height: "30px",
  margin: "0px 0px 0px auto",
  fontSize: "16px",
  lineheight: "24px",
  weight: "600",
  color: "white",
};
const StyledBreadCrumb = styled(BreadCrumbBox)`
  margin: 0px;
  .m-sm--auto {
    ${media.mobile`margin:10px auto;`}
  }
`;

const SizerRates = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { id } = useParams();
  useSizerData();
  const sizerList = useSelector((state) => state.sizer.sizer) || [];
  const SizerData = sizerList.find(
    (sizer) => String(sizer.sizer_id) === String(id)
  );
  const sizerRate = SizerData ? parseSizerRates(SizerData) : [];

  const AddQualityRate = () => {
    dispatch({
      type: "MODAL_VIEW",
      payload: { flag: true },
    });
  };
  const onCreate = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };

  if (!SizerData) {
    return <Loading />;
  }

  return (
    <Grid>
      <Section padding="20px" className="mt-50 mb-50">
        <StyledBreadCrumb tittle="Sizer Rates">
          <Button {...btnProps} className="m-sm--auto" onClick={AddQualityRate}>
            Add Quality Rate
          </Button>
          <SizerRatesTabel
            className="mt-20"
            pagination={false}
            sizerRates={sizerRate}
          />
        </StyledBreadCrumb>
      </Section>
      <Modal
        closable={false}
        visible={state.visible}
        onCreate={onCreate}
        footer={false}
        maxwidth="589px"
        onCancel={() => dispatch({ type: "MODAL_VIEW", payload: false })}
        tittle="Add Quality Rate"
      >
        <AddSizerQualityRate onCreate={onCreate} />
      </Modal>
    </Grid>
  );
};

export default SizerRates;
